import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, TextField } from '@material-ui/core';
import Theme from '../ui/Theme';
import Search from '../../assets/Search';
import DealershipCard from './DealershipCard';
import ShowProgress from '../ui/Backdrop';
import Service from '../../apis/service';
import { getPlanDetails, showProgress } from '../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  leftBarTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
  },
  leftBarTitleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '2px',
    color: Theme.palette.primary.main,
  },
  leftPane: {
    width: '100%',
    height: '70vh',
    border: '1px solid #F4F4F4',
    overflow: 'hidden',
  },
  leftPaneTitleFrame: {
    padding: '12px',
  },
  searchFrame: {
    width: '100%',
    height: '42px',
    left: 'calc(50% - 440px/2)',
    marginTop: '12px',
    background: '#FAFAFA',
    border: '1px solid #F4F4F4',
    boxSizing: 'border-box',
  },
  searchStyle: { padding: '10px' },
  dealershipFrame: {
    width: '100%',
    padding: '12px',
    height: '46vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },

  dealershipSubTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));
const LeftPlanContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const planDetails = useSelector((state) => state.getPlanDetails.plandetails);

  const [assignedDealerships, setAssignedDealerships] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [filterArray, setFilterArray] = useState([]);

  useEffect(() => {
    if (planDetails?.id) {
      getDealerships(planDetails?.id);
    }
    // Intentionally scoped to id + _refreshAfterSave only — other planDetails
    // property changes (e.g. assignedDealershipsCount) must not re-trigger this fetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planDetails?.id, planDetails?.dealershipsRefreshKey]);

  const getDealerships = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.PLAN_DEALERSHIP.replace('ID', id), '')
      .then((response) => {
        setAssignedDealerships(response);
        setFilterArray(response);
        dispatch(getPlanDetails({ ...planDetails, assignedDealershipsCount: response.length }));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const handleSearchChange = (e) => {
    const input = e.target.value;
    setSearchVal(input);
    const filteredArray = input
      ? assignedDealerships.filter((item) => item.name.toLowerCase().includes(input.toLowerCase()))
      : assignedDealerships;
    setFilterArray(filteredArray);
  };

  return (
    <div>
      <Grid container direction="column" className={classes.leftPane}>
        <Grid item>
          <Grid container direction="row" className={classes.leftPaneTitleFrame}>
            <Grid item className={classes.leftBarTitleText}>
              Dealership
            </Grid>
            <Grid item className={classes.leftBarTitleSubText}>
              {assignedDealerships ? ` (${assignedDealerships?.length})` : ' (0)'}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" className={classes.searchFrame} justifyContent="start" alignItems="center">
            <Grid item className={classes.searchStyle}>
              <Search />
            </Grid>
            <Grid item style={{ width: '80%' }}>
              <TextField
                id="searchId"
                name="search"
                required
                autoComplete="off"
                autoSave="off"
                onChange={handleSearchChange}
                placeholder="Search for Dealership"
                value={searchVal}
                InputProps={{
                  disableUnderline: true,
                  className: classes.searchText,
                }}
                rows={1}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.dealershipFrame}>
          <Grid container direction="row" justifyContent="flex-start">
            {filterArray?.map((val) => (
              <DealershipCard textVal={val.name} empCount={val.employeesCount} />
            ))}
          </Grid>
        </Grid>
      </Grid>
      <ShowProgress />
    </div>
  );
};

export default LeftPlanContent;
